module.exports = __webpack_public_path__ + "static/flexBg-4a6a1cfb96d82edc3ae55fcb117f73ac.png";